import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-delete-policy-control',
  templateUrl: './delete-policy-control.component.html',
  styleUrls: ['./delete-policy-control.component.scss']
})
export class DeletePolicyControlComponent implements OnInit {
  public deleteDialogOpened = false;
  @Input() policycontrol: any;
  @Output() Change: EventEmitter<{
    dialogstatus; policycontrol
  }> = new EventEmitter();
  constructor() { }

  ngOnInit() {
  }

  public Delete() {
    this.Change.emit({
      dialogstatus: this.deleteDialogOpened,
      policycontrol: this.policycontrol
    });
  }

  public Cancel() {
    this.Change.emit({ dialogstatus: this.deleteDialogOpened, policycontrol: "" });
  }
}